import { createReducer, on } from '@ngrx/store';
import { setReferenceInputsAction } from './referenceInputs.actions';


export const initialState = {};

export const referenceInputsReducer = createReducer(
  initialState,
  on(setReferenceInputsAction, (state, { referenceInputs }) => referenceInputs)
);